import React from "react";
import FormHeader from "./FormHeader";
import Footer from "./Footer";

const Layout = (props) => {
    return (
        <div className="page-wrapper">
            <FormHeader></FormHeader>
            {props.children}
            {/* <Footer></Footer> */}
        </div>
    )
}

export default Layout;